import * as THREE from 'three';
import { Modifier } from './Modifier';
export class FacetModifier extends Modifier {
    constructor(disabled, parameters) {
        super('facet', disabled, parameters, true);
    }
    apply(geometry) {
        if (this.disabled)
            return;
        const positions = geometry.attributes.position.array;
        const { facetCount, facetDepth, facetBlend } = this.parameters;
        // Create a temporary array to store the modified positions
        const newPositions = new Float32Array(positions.length);
        // Pre-calculate facet angles for efficiency
        const facetAngle = (2 * Math.PI) / facetCount;
        const halfFacetAngle = facetAngle / 2;
        for (let i = 0; i < positions.length; i += 3) {
            const x = positions[i];
            const y = positions[i + 1];
            const z = positions[i + 2];
            // Calculate the angle around the Y axis
            const angle = Math.atan2(z, x);
            // Calculate which facet this point belongs to
            const facetIndex = Math.floor(angle / facetAngle);
            const targetAngle = facetIndex * facetAngle + halfFacetAngle;
            // Calculate the radius in the XZ plane
            const radius = Math.sqrt(x * x + z * z);
            // Calculate the new position based on the facet
            const newX = radius * Math.cos(targetAngle);
            const newZ = radius * Math.sin(targetAngle);
            // Calculate distance from facet center
            const angleDiff = Math.abs(angle - targetAngle);
            const normalizedAngleDiff = Math.min(angleDiff, Math.PI - angleDiff) / halfFacetAngle;
            // Apply smooth blending between original and faceted position
            const blendFactor = Math.pow(normalizedAngleDiff, facetBlend);
            const finalX = x + (newX - x) * (1 - blendFactor) * facetDepth;
            const finalZ = z + (newZ - z) * (1 - blendFactor) * facetDepth;
            // Store the new positions
            newPositions[i] = finalX;
            newPositions[i + 1] = y; // Keep Y position unchanged
            newPositions[i + 2] = finalZ;
        }
        // Update the geometry with the new positions
        geometry.setAttribute('position', new THREE.BufferAttribute(newPositions, 3));
        geometry.attributes.position.needsUpdate = true;
        geometry.computeVertexNormals();
    }
}
